import type { ReactNode } from "react";

/** One tab's section: the layout owns the page title, so these are h2. */
export function SettingsSection({
  title,
  description,
  className = "",
  children,
}: {
  title: string;
  description: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <section className={className}>
      <h2 className="text-sm font-semibold text-foreground">{title}</h2>
      <p className="mb-4 mt-0.5 text-sm text-foreground/70">{description}</p>
      {children}
    </section>
  );
}

export function SettingsSkeleton({ steps = 3 }: { steps?: number }) {
  return (
    <div className="animate-pulse rounded-lg bg-surface p-4">
      {Array.from({ length: steps }, (_, step) => (
        <div key={step} className="flex gap-3 py-2">
          <div className="h-5 w-5 shrink-0 rounded-full bg-muted" />
          <div className="min-w-0 flex-1">
            <div className="h-3 w-40 rounded bg-muted" />
            <div className="mt-2 h-2.5 w-full max-w-sm rounded bg-muted" />
          </div>
        </div>
      ))}
    </div>
  );
}
